// extracted by mini-css-extract-plugin
export default {"ChartInfoContainer":"ChartInfo_ChartInfoContainer__Co8y6","ChartInfoComparisonContainer":"ChartInfo_ChartInfoComparisonContainer__zf5zq"};